import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import DataTable from "@/components/Tables/DataTable"
import { useEffect, useState } from "react"
import { isAdminPortal } from "@/utilities/domain"
import {
  ReportBranchFilter,
  ReportBranchProvider,
  useReportBranch,
  withBranchColumn,
} from "@/components/Reports/ReportBranchFilter"

const adminColumns = withBranchColumn(columns)

export default function StockTransactionList() {
  return (
    <>
      <CrudProvider>
        <ReportBranchProvider>
          <StockTransactionTable />
        </ReportBranchProvider>
      </CrudProvider>
    </>
  )
}

function StockTransactionTable() {
  // The company admin portal lists every branch's movements, or a selected one
  const adminPortal = isAdminPortal()
  const { branchId } = useReportBranch()
  const branchFilter = React.useMemo(
    () => ({ branch_id: branchId }),
    [branchId]
  )

  return (
    <>
      <CustomTable
        columns={adminPortal ? adminColumns : columns}
        apiPath="stock-transactions"
        action={false}
        addBtn={false}
        label="Stock Transactions"
        onExport={true}
        hardcodedFilters={adminPortal ? branchFilter : undefined}
        exportParams={adminPortal ? branchFilter : undefined}
        renderFilters={
          adminPortal ? () => <ReportBranchFilter sx={{ mb: 0 }} /> : undefined
        }
      />
    </>
  )
}
